import { render, staticRenderFns } from "./Assessment2.vue?vue&type=template&id=59127184&scoped=true"
import script from "./Assessment2.vue?vue&type=script&lang=js"
export * from "./Assessment2.vue?vue&type=script&lang=js"
import style0 from "./Assessment2.vue?vue&type=style&index=0&id=59127184&prod&lang=scss"
import style1 from "./Assessment2.vue?vue&type=style&index=1&id=59127184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59127184",
  null
  
)

export default component.exports